import React from "react";
import { useNavigate } from "react-router-dom";
import {motion } from "motion/react"
import { ArrowRight } from 'lucide-react';


export default function HeroPage({scrollToFeatures}){
      const navigate = useNavigate();

    return (
<div className="relative min-h-screen bg-white flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2 }}
          className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-br from-yellow-300 via-orange-300 to-pink-300 rounded-full blur-3xl opacity-40"
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, delay: 0.2 }}
          className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-gradient-to-br from-purple-300 via-pink-300 to-rose-300 rounded-full blur-3xl opacity-40"
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, delay: 0.4 }}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-pink-200 via-purple-200 to-indigo-200 rounded-full blur-3xl opacity-30"
        />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="text-7xl sm:text-8xl lg:text-9xl font-black mb-6 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent leading-tight drop-shadow-sm">
            Storii
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4 leading-snug"
        >
          It's a new generation platform for everyone
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-lg sm:text-xl lg:text-2xl text-slate-600 mb-12 max-w-2xl mx-auto font-medium"
        >
          Go ahead and read hundreds of stories.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button onClick={() => navigate('/waitlist')} className="group relative px-10 py-5 bg-black text-white rounded-2xl font-bold text-lg shadow-2xl hover:shadow-3xl hover:scale-105 transition-all duration-300 flex items-center gap-3 overflow-hidden">
            <span className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <span className="relative">Join Waitlist</span>
            <ArrowRight className="relative w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>

          <button onClick={scrollToFeatures} className="px-10 py-5 bg-white text-slate-900 rounded-2xl font-bold text-lg border-2 border-slate-300 hover:border-purple-500 hover:shadow-xl transition-all duration-300 hover:scale-105">
            See More
          </button>
        </motion.div>
       
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-20 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-6 h-10 border-2 border-slate-400 rounded-full flex items-start justify-center p-1"
        >
          <div className="w-1.5 h-3 bg-gradient-to-b from-purple-600 to-pink-600 rounded-full" />
        </motion.div>
      </motion.div>
    </div>
    )
}